import * as React from 'react';
import css from '../../group.module.scss';
import { getTitleContainerId } from '../../../../utils/group';

type Props = {
  components: React.ReactNode;
  description?: React.ReactNode;
  id: string;
  label?: React.ReactNode;
};

const BuieSubmitterGroup = React.memo<Props>((props: Props) => {
  const { id, label, description, components } = props;

  return (
    <>
      <div className="group-title-container" id={getTitleContainerId(id)}>
        {label ? <div className={css.groupLabel}>{label}</div> : null}
        {description ? (
          <div className={css.groupDescription}>{description}</div>
        ) : null}
      </div>
      {components}
    </>
  );
});

export { BuieSubmitterGroup };
export default BuieSubmitterGroup;
